import { useQuery } from '@tanstack/react-query';

type EnvBadgeConfig = {
  show: boolean;
  clientName: string;
  envName: string;
};

export const useEnvBadgeConfig = () =>
  useQuery<EnvBadgeConfig>({
    queryKey: ['env-badge-config'],
    queryFn: async () => {
      const response = await fetch('/env-badge-config');

      if (!response.ok) {
        throw new Error(`Failed to fetch env config: ${response.status}`);
      }

      return response.json();
    },
    staleTime: Infinity,
    retry: false,
  });
